import React from "react";
import { Link } from "react-router-dom";
import "./ctatab.css"; // Import the CSS file

function CtaTab() {
  return (
    <div className="container cta-margin">
      <div className="cta-container">
        <div className="cta-text">
          Empowering your success with expert developers and innovative
          solutions!
        </div>
        <Link to="/contact">
          <button className="cta-button">Get In Touch</button>
        </Link>
      </div>
    </div>
  );
}

export default CtaTab;
